	function isEmpty(obj){
		for (const key in obj) {
		  if (obj.hasOwnProperty(key)) {
		    const value = obj[key];
		    if (value === null || value === undefined || value === '') {
		      return false;
		    } else if (Array.isArray(value)) {
		      if (value.length === 0 || !value.every(isEmpty)) {
		        return false;
		      }
		    } else if (typeof value === 'object' && !isEmpty(value)) {
		      return false;
		    }
		  }
		}
		return true;
	}
	function throttle(func, delay) {
	  let timerId = null;
	  let lastExecTime = 0;
	
	  return function(...args) {
	    const currentTime = Date.now();
	
	    if (currentTime - lastExecTime < delay) {
	      clearTimeout(timerId);
	      timerId = setTimeout(() => {
	        lastExecTime = currentTime;
	        func.apply(this, args);
	      }, delay);
	    } else {
	      lastExecTime = currentTime;
	      func.apply(this, args);
	    }
	  };
	}
export  default{isEmpty,throttle}